import { Button, Space, Table, Checkbox } from "antd";
import vCardsJS from "vcards-js";
import { CSVLink } from "react-csv";
import React from "react";
import { useState, useEffect, useRef } from "react";
import Layout from "../../../components/Layout";
import { Domain, request } from "../../../config/API";
import { ReloadOutlined, DownloadOutlined } from "@ant-design/icons";
import { COLORS } from "../../../config/theme";
import { openNotification } from "../../../redux/actions/Notification/notifications.action";
import { formatDistanceToNow } from "date-fns";
import moment from "moment";

const headers = [
  { label: "First Name", key: "firstName" },
  { label: "Last Name", key: "lastName" },
  { label: "Phone No", key: "phoneNo" },
  { label: "Email", key: "email" },
  { label: "Job Title/Position", key: "jobTitle" },
  { label: "Company", key: "company" },
  { label: "Address", key: "address" },
  { label: "Comment", key: "comment" },
];
const ListLeadGenerations = () => {
  const { primaryDark } = COLORS;
  const [leadGeneration, setLeadGeneration] = useState([]);
  const [massDownload, setMassDownload] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  // pagination
  const [count, setCount] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  function handlePageChange(current) {
    setCurrentPage(current);
  }
  function handleSizeChange(a, b, c) {
    setCurrentPage(a);
    setPageSize(b);
  }

  const getLeadGeneration = () => {
    setIsLoading(true);
    request
      .get("leadgeneration/leadgeneration", {
        params: { pageSize, pageNumber: currentPage },
      })
      .then(({ data: { data } }) => {
        setLeadGeneration(data?.leadGeneration);
        setCount(data?.count);
        setIsLoading(false);
        // setAdmins(data?.admin);
      })
      .catch((err) => {
        const error = err?.response?.data.data || "Something Happened";
        openNotification({
          message: "Error",
          description: error,
          icon: "error",
        });
        setIsLoading(false);
      });
  };
  //eslint-disable-next-line
  useEffect(getLeadGeneration, [currentPage, pageSize]);
  const downloadVCF = (info) => {
    const {
      firstName,
      lastName,
      phoneNo,
      email,
      jobTitle,
      company,
      address,
      comment,
    } = info;
    let vcfCard = vCardsJS();
    if (firstName) vcfCard.firstName = firstName;
    if (lastName) vcfCard.lastName = lastName;
    if (email) vcfCard.email = email;
    if (phoneNo) vcfCard.cellPhone = phoneNo;
    if (jobTitle) vcfCard.title = jobTitle;
    if (company) vcfCard.organization = company;
    if (address) vcfCard.workAddress.street = address;
    if (comment) vcfCard.note = comment;

    const element = document.createElement("a");
    const file = new Blob([vcfCard.getFormattedString()], {
      type: "text/vcard",
    });
    element.href = URL.createObjectURL(file);
    element.download = firstName + ".vcf";
    document.body.appendChild(element);
    element.click();
  };
  const handleMultiSelect = (info) => {
    const tempMass = [...massDownload];
    const checkIf = massDownload.find((item) => item._id === info._id);
    if (checkIf) {
      const temp = massDownload.filter((item) => item._id !== info._id);
      setMassDownload(temp);
    } else {
      tempMass.push(info);
      setMassDownload(tempMass);
    }
  };
  const truncate = (input) => {
    const temp = input || "";
    return temp?.length > 20 ? `${temp?.substring(0, 20)}...` : temp;
  };
  const Buttons = ({ text }) => {
    const { primaryDark } = COLORS;
    const [open, setOpen] = useState(false);
    function useOutsideAlerter(ref) {
      useEffect(() => {
        function handleClickOutside(event) {
          if (ref.current && !ref.current.contains(event.target)) {
            setOpen(false);
          }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [ref]);
    }
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);
    return (
      <div
        style={{
          position: "relative",
        }}
      >
        <div
          style={{
            cursor: "pointer",
            backgroundColor: primaryDark,
            borderRadius: ".3rem",
            justifyContent: "center",
            textAlign: "center",
            padding: ".5rem",
          }}
          onClick={() => setOpen((prev) => !prev)}
        >
          <span
            style={{ color: "#ffffff", fontWeight: "400", fontSize: "1.15rem" }}
          >
            Action menu
          </span>
        </div>
        {open && (
          <div
            ref={wrapperRef}
            style={{
              position: "absolute",
              right: 0,
              padding: "10px 20px",
              background: "white",
              zIndex: 1,
              borderRadius: "1rem",
              outline: "1px solid lightGray",
              boxShadow: "0px 0px 5px .5px",
            }}
          >
            <Space
              style={{
                flexDirection: "column",
                paddingTop: ".75rem",
                paddingBottom: ".75rem",
              }}
            >
              {text?.profileImage && (
                <Button
                  style={{
                    background: primaryDark,
                    borderColor: primaryDark,
                    fontWeight: "400",
                    fontSize: "1rem",
                  }}
                  shape="round"
                  type="primary"
                  onClick={() => {
                    const url = `${Domain}/Data/${text?.profileImage}`;
                    fetch(url).then((response) => {
                      response.blob().then((blob) => {
                        let url = window.URL.createObjectURL(blob);
                        let a = document.createElement("a");
                        a.href = url;
                        a.download = text?.profileImage;
                        a.click();
                      });
                    });
                  }}
                >
                  Download Image
                </Button>
              )}
              {text?.file && (
                <Button
                  style={{
                    background: primaryDark,
                    borderColor: primaryDark,
                    fontWeight: "400",
                    fontSize: "1rem",
                  }}
                  shape="round"
                  type="primary"
                  onClick={() => {
                    const url = `${Domain}/docs/${text?.file}`;
                    fetch(url).then((response) => {
                      response.blob().then((blob) => {
                        let url = window.URL.createObjectURL(blob);
                        let a = document.createElement("a");
                        a.href = url;
                        a.download = text?.file;
                        a.click();
                      });
                    });
                  }}
                >
                  Download File
                </Button>
              )}
              <Button
                style={{
                  background: primaryDark,
                  borderColor: primaryDark,
                  fontWeight: "400",
                  fontSize: "1rem",
                }}
                shape="round"
                type="primary"
                onClick={() => {
                  downloadVCF(text);
                }}
              >
                Download VCF
              </Button>
              <CSVLink
                filename={`${Date.now()}.csv`}
                headers={headers}
                data={[text]}
              >
                <Button
                  shape="round"
                  type="primary"
                  style={{
                    background: primaryDark,
                    borderColor: primaryDark,
                    fontWeight: "400",
                    fontSize: "1rem",
                  }}
                >
                  Download CSV
                </Button>
              </CSVLink>
            </Space>
          </div>
        )}
      </div>
    );
  };
  const LongTextDisplay = ({ text }) => {
    const [open, setOpen] = useState(false);
    function useOutsideAlerter(ref) {
      useEffect(() => {
        function handleClickOutside(event) {
          if (ref.current && !ref.current.contains(event.target)) {
            setOpen(false);
          }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [ref]);
    }
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef);
    return (
      <div
        style={{
          position: "relative",
        }}
      >
        <div
          style={{ cursor: "pointer", fontWeight: "400", fontSize: "1.15rem" }}
          onClick={() => setOpen((prev) => !prev)}
        >
          <span>{truncate(text)}</span>
        </div>
        {open && (
          <div
            ref={wrapperRef}
            style={{
              position: "absolute",
              right: 0,
              padding: "10px 20px",
              background: "white",
              outline: "1px solid lightGray",
              boxShadow: "0px 0px 5px .5px",
              zIndex: 1,
              borderRadius: "1rem",
              width: "25rem",
              fontWeight: "400",
              fontSize: "1.15rem",
            }}
          >
            <Space
              style={{
                flexDirection: "column",
                paddingTop: ".75rem",
                paddingBottom: ".75rem",
              }}
            >
              <span>{text}</span>
            </Space>
          </div>
        )}
      </div>
    );
  };
  const columns = [
    {
      title: "",
      key: "checkbox",
      render: (text) => {
        return (
          <Space>
            {true && (
              <Checkbox
                checked={massDownload.find((item) => item._id === text._id)}
                onChange={() => {
                  handleMultiSelect(text);
                }}
              />
            )}
          </Space>
        );
      },
      width: "3%",
    },
    {
      title: "First Name",
      dataIndex: ["lead", "firstName"],
      key: "firstName",
      width: "12%",
      render: (item) => {
        return (
          <span style={{ fontWeight: "400", fontSize: "1.15rem" }}>{item}</span>
        );
      },
    },
    {
      title: "Last Name",
      dataIndex: ["lead", "lastName"],
      key: "lastName",
      width: "12%",
      render: (item) => {
        return (
          <span style={{ fontWeight: "400", fontSize: "1.15rem" }}>{item}</span>
        );
      },
    },
    {
      title: "Company Name",
      dataIndex: ["lead", "company"],
      key: "company",
      width: "16%",
      render: (item) => {
        return (
          <span style={{ fontWeight: "400", fontSize: "1.15rem" }}>{item}</span>
        );
      },
    },
    {
      title: "Phone Number",
      dataIndex: ["lead", "phoneNo"],
      key: "phoneNo",
      width: "16%",
      render: (item) => {
        return (
          <span
            style={{
              cursor: "pointer",
              fontWeight: "400",
              fontSize: "1.15rem",
            }}
            onClick={() => {
              window.open("tel:" + item);
            }}
          >
            {item}
          </span>
        );
      },
    },
    {
      title: "Email",
      dataIndex: ["lead", "email"],
      key: "email",
      width: "16%",
      render: (item) => {
        return (
          <span
            style={{
              cursor: "pointer",
              fontWeight: "400",
              fontSize: "1.15rem",
            }}
            onClick={() => {
              window.open("mailto:" + item);
            }}
          >
            {truncate(item)}
          </span>
        );
      },
    },
    {
      title: "Job Title/Position",
      dataIndex: ["lead", "jobTitle"],
      key: "jobTitle",
      width: "16%",
      render: (item) => {
        return (
          <span style={{ fontWeight: "400", fontSize: "1.15rem" }}>{item}</span>
        );
      },
    },
    {
      title: "Address",
      dataIndex: ["lead", "address"],
      key: "address",
      width: "16%",
      render: (text) => {
        return <LongTextDisplay text={text} />;
      },
    },
    {
      title: "Website",
      dataIndex: ["lead", "website"],
      key: "website",
      width: "16%",
      render: (item) => {
        return (
          <span
            style={{
              cursor: "pointer",
              fontWeight: "400",
              fontSize: "1.15rem",
            }}
            onClick={() => {
              window.open(item, "_blank");
            }}
          >
            {truncate(item)}
          </span>
        );
      },
    },
    {
      title: "Comment",
      dataIndex: ["lead", "comment"],
      key: "comment",
      width: "16%",
      render: (text) => {
        return <LongTextDisplay text={text} />;
      },
    },
    {
      title: "Card Owner",
      dataIndex: ["owner", "fullName"],
      key: "fullName",
      width: "16%",
      render: (item) => {
        return (
          <span style={{ fontWeight: "400", fontSize: "1.15rem" }}>{item}</span>
        );
      },
    },
    {
      width: "16%",
      title: "Date",
      dataIndex: ["lead", "createdAt"],
      key: "updatedAt",
      render: (item) => {
        return (
          <span style={{ fontWeight: "400", fontSize: "1.15rem" }}>
            {moment(new Date(item)).format("D/MM/YYYY")}
          </span>
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      dataIndex: "lead",
      render: (text) => {
        return <Buttons text={text} />;
      },
      width: "6%",
    },
  ];

  return (
    <Layout heading="Lead Inbox" hasBadge stat={count}>
      <Space style={{ marginBottom: 24, marginTop: 24, float: "right" }}>
        {massDownload.length > 1 && (
          <CSVLink
            filename={`${Date.now()}.csv`}
            data={massDownload}
            headers={headers}
          >
            <Button
              shape="round"
              type="primary"
              style={{ background: primaryDark, borderColor: primaryDark }}
              icon={<DownloadOutlined />}
            >
              Mass Download CSV
            </Button>
          </CSVLink>
        )}
        <Button
          shape="round"
          type="primary"
          style={{ background: primaryDark, borderColor: primaryDark }}
          onClick={getLeadGeneration}
          icon={<ReloadOutlined />}
        >
          Refresh
        </Button>
      </Space>
      <Table
        size="large"
        dataSource={leadGeneration}
        rowKey={({ _id }) => _id}
        columns={columns}
        loading={isLoading}
        pagination={{
          hideOnSinglePage: true,
          pageSize: pageSize,
          current: currentPage,
          total: count,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
          // showTotal: (total) => `Total ${total} items`,
          onChange: handlePageChange,
          showSizeChanger: true,
          onShowSizeChange: handleSizeChange,
        }}
      />
    </Layout>
  );
};

export default ListLeadGenerations;
